export default __webpack_public_path__ + "static/helix-bq-5-cba605c02c1a8157c0c862ee19f667fa.jpg";